import axios from "axios"
import { IGetConsultantsMaladiesListingRequestModel, IGetConsultantsMaladiesResponseModel } from "./_models"
import { CONST_API_BUSINESS_CONSULTANT_DECLARATION_MALADIES_LISTING_ENDPOINT } from "../../../../../../endpoints"

export function getConsultantsMaladiesListingRequest(payload: IGetConsultantsMaladiesListingRequestModel) {
     return axios.post<IGetConsultantsMaladiesResponseModel>(CONST_API_BUSINESS_CONSULTANT_DECLARATION_MALADIES_LISTING_ENDPOINT, payload)
}
